import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  ReactComponent as SupportIcon
} from '@pagerduty/design-system/dist/icons/help-circle-outline.svg';
import {
  ReactComponent as AppsIcon
} from '@pagerduty/design-system/dist/icons/apps.svg';
import {
  ReactComponent as GiftIcon
} from './gift-icon.svg';

import { currentUserData } from '../../../features/fe-data/selectors';
import getPermissions from '../permissions';
import { LINK_IDS } from '../nav-links';

import { currentUserPropTypes } from '../../../util/propTypes';
import { fetchContentfulResults } from '../../../features/contentful/actions';

import PdxNavPanel from '../PdxNavPanel';
import PdxNavPanelSection from '../PdxNavPanel/PdxNavPanelSection';
import PdxNavPanelSectionHeader from '../PdxNavPanel/PdxNavPanelSectionHeader';
import PdxNavPanelSectionItem from '../PdxNavPanel/PdxNavPanelSectionItem';
import PdxNavLink from '../PdxNavLink';

import SearchBox from '../SearchBox';
import AppsPanel from '../AppsPanel';
import WhatsNewModal from '../../WhatsNewModal';
import NewNavToggler from '../../NewNavToggler';

import sections from './sections';
import '../NavbarVariant.css';
import '../MagicLine.css';

export const RightNavComponent = ({
  currentUser,
  permissions,
  isDeveloperNav,
  fetchContentful
}) => {
  const hasSearch = !permissions.currentUserReadOnlyLimited && permissions.globalSearch;
  const hasDeveloper = !permissions.currentUserReadOnlyLimited && permissions.appDirectory;
  const numItems = 3 + (isDeveloperNav && 1) + (hasSearch && 1) + (hasDeveloper && 1);
  return (
    <React.Fragment>
      {hasSearch && <SearchBox />}
      <div className="nav-item">
        <PdxNavLink
          id={LINK_IDS.SUPPORT}
          onMouseEnter={() => fetchContentful()}
          label="support"
          className="icon"
        >
          <SupportIcon className="ionicon" />
        </PdxNavLink>
        <PdxNavPanel right={numItems >= 5 ? 186 : 136} hasBottomCap>
          <PdxNavPanelSection>
            <PdxNavPanelSectionHeader newTab>Support</PdxNavPanelSectionHeader>
            <PdxNavPanelSectionItem id={LINK_IDS.KNOWLEDGE_BASE} newTab />
            <PdxNavPanelSectionItem newTab id={LINK_IDS.COMMUNITY} />
            <PdxNavPanelSectionItem newTab id={LINK_IDS.CONTACT_SUPPORT} />
            <NewNavToggler />
          </PdxNavPanelSection>
        </PdxNavPanel>
      </div>
      {hasDeveloper && (
        <div className="nav-item">
          <PdxNavLink
            id={LINK_IDS.DEVELOPER}
            sectionItems={sections.Developer}
            label="apps"
            className="icon"
          >
            <AppsIcon className="ionicon" />
          </PdxNavLink>
          <AppsPanel />
        </div>
      )}

      <div className="nav-item">
        <WhatsNewModal>
          {props => (
            <PdxNavLink
              id={LINK_IDS.WHATS_NEW}
              onClick={props.onClick}
              onMouseEnter={() => fetchContentful()}
              label="whats-new"
              className="icon"
            >
              <GiftIcon className="ionicon" />
            </PdxNavLink>
          )}
        </WhatsNewModal>
      </div>

      <div className="nav-item">
        <PdxNavLink
          id={LINK_IDS.ACCOUNT}
          sectionItems={sections.Account}
          label="account"
          className="pdx-nav-link-account"
        >
          <img
            src={currentUser.avatarUrl}
            size="30"
            width="30"
            height="30"
            alt={currentUser.name}
            title={currentUser.name}
          />
        </PdxNavLink>
        <PdxNavPanel right={10} width={permissions.accountSettings ? 250 : 230}>
          <PdxNavPanelSection>
            <PdxNavPanelSectionItem id={LINK_IDS.MY_PROFILE} />
            <PdxNavPanelSectionItem id={LINK_IDS.ACCOUNT_SETTINGS_OWNER} />
            <PdxNavPanelSectionItem id={LINK_IDS.ACCOUNT_SETTINGS_ADMIN} />
            <PdxNavPanelSectionItem id={LINK_IDS.ACCOUNT_SUBSCRIPTIONS} />
            <PdxNavPanelSectionItem id={LINK_IDS.LOG_OUT} />
          </PdxNavPanelSection>
        </PdxNavPanel>
      </div>
      <span className="magicLine" style={{ '--rightNavItems': numItems }} />
    </React.Fragment>
  );
};

RightNavComponent.defaultProps = {
  isDeveloperNav: false,
  fetchContentful: () => {}
};

RightNavComponent.propTypes = {
  ...currentUserPropTypes,
  fetchContentful: PropTypes.func,
  permissions: PropTypes.objectOf(PropTypes.bool).isRequired,
  isDeveloperNav: PropTypes.bool
};

const mapStateToProps = state => ({
  currentUser: currentUserData(state),
  permissions: getPermissions(state)
});

const mapActionsToProps = { fetchContentful: fetchContentfulResults };

export default connect(mapStateToProps, mapActionsToProps)(RightNavComponent);
